export default __webpack_public_path__ + "static/media/logo.3443060a.svg";